export default __webpack_public_path__ + "static/media/close~kyoudgeP.b03ea909.png";